import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerLinks = {
    product: [
      { label: 'About', path: '/about' },
      { label: 'Pricing', path: '/pricing' },
      { label: 'Features', path: '#' }
    ],
    support: [
      { label: 'Contact', path: '/contact' },
      { label: 'Help Center', path: '#' },
      { label: 'Documentation', path: '#' }
    ],
    contact: [
      { label: 'info@vidhyalaya.com', href: 'mailto:info@vidhyalaya.com' },
      { label: '+91 98765 43210', href: 'tel:+919876543210' }
    ]
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <motion.div 
          className="footer-content"
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="footer-brand">
            <div className="brand">
              <img src="Logo&favicon/logo-white.png" alt="Vidhyalaya" />
            </div>
            <p>Revolutionary school management system for modern education.</p>
          </div>
          
          <div className="footer-links">
            <h4>Product</h4>
            {footerLinks.product.map((link, index) => (
              <Link key={index} to={link.path}>{link.label}</Link>
            ))}
          </div>
          
          <div className="footer-links">
            <h4>Support</h4>
            {footerLinks.support.map((link, index) => (
              <Link key={index} to={link.path}>{link.label}</Link>
            ))}
          </div>
          
          <div className="footer-links">
            <h4>Contact</h4>
            {footerLinks.contact.map((link, index) => (
              <a key={index} href={link.href}>{link.label}</a>
            ))}
          </div>
        </motion.div>
        
        <motion.div 
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          <p>&copy; 2024 Vidhyalaya. All rights reserved. | Powered by <strong>Mohit IT Consultant</strong></p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;